export const addSelectObject = (payload, api) => ({
    type: 'ADD_SELECT_OBJECT',
    payload: payload,
    api:api
});
